// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2EVsq","signatureBlock":"Footer_signatureBlock__33cxV","signature":"Footer_signature__idBd2"};